import { Component } from "react";
import { Navigate, withRouter } from "react-router";
import SocieteFactureBox from "../../models/SocieteFactureBox";

import BCService from "../../services/BCService";
import ExtratFacture from "../../models/ExtratFacture";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SocieteBox from "../../models/SocieteBox";
import UtilsFormule from "../../utils/UtilsFormule";
export default class ViewBCDetails extends Component {
  state = {
    BC: "",
  };
  constructor(props) {
    super(props);
    this.state = {
      idBC: "",
      alert_message: "",
      BC: "",
      societePartner: "",
      societeCliente: "",
      extracts: [],
    };
  }



  validateBC(event) {
    BCService.validateBC(localStorage.getItem("idBC"))
      .then((response) => {
        console.log("response", response.data["BC"]);
        if (response.data["Bill"] === "not generated") {
          this.setState({ alert_message: "error" });
          toast.error("Une erreur a survenue");
        } else {
          this.setState({ alert_message: "success" });
          toast.success("Bon de commande validée et ajoutée avec succée");

          setTimeout(() => {
            // this.props.history.push("/listBCValidated");
            this.props.history.push("/getListSocieteAchatAllBC");
          }, 5000);
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }

  deleteBCDraft(event) {
    BCService.deleteBCDraft(localStorage.getItem("idBC"))
      .then((response) => {
        console.log("response", response.data["BC"]);
        if (response.data["Bill"] === "not deleted") {
          this.setState({ alert_message: "error" });
        } else {
          this.props.history.push("/addBCAchat");
          this.setState({ alert_message: "success" });
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }

  componentDidMount() {
    this.forceUpdate();
    BCService.getBCAndExrats(localStorage.getItem("idBC"))
      .then((response) => {
        console.log("response", response.data["BCExtrat"]);
        if (response.data["BCExtrat"] === "vide") {
          toast.error("Une erreur a survenue");

          // this.setState({ alert_message: "error" });
        } else {
          console.log("In BCExtrat else");
          this.setState({
            societeCliente: response.data["BCExtrat"].societeCliente,
          });
          this.setState({
            societePartner: response.data["BCExtrat"]["societePartner"],
          });
          this.setState({
            BC: response.data["BCExtrat"]["bc"],
          });
          this.setState({
            extratBill: response.data.BCExtrat["extracts"],
          });

          // console.log(
          //   "SocieteCliente",
          //   response.data["BCExtrat"].societeCliente
          // );
          // console.log("SocietePartner", this.state.societePartner);
          // console.log("bill", this.state.bill);
          // console.log("extrats", this.state.extratBill);
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
        toast.error("Une erreur a survenue");
      });
  }
  addExtratToView() {

    if (this.state.extratBill && this.state.extratBill.length === 0) {

      return (
        <div className="row">
          <div className="col-md-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else if (
      this.state.extratBill.length === 1 &&
      this.state.extratBill[0]["name"] === "" &&
      this.state.extratBill[0]["value"] === "" &&
      this.state.extratBill[0]["description"] === ""
    ) {
      return (
        <div className="row">
          <div className="col-md-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {
      console.log("extracts", this.state.extratBill);
      return (<div className="row" style={{ marginTop: 30, marginLeft: 10 }}>
        <div className="col-md-12 table-responsive">
          <p className="lead">Les produits:</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Titre du libelle</th>
                <th>Montant</th>
              </tr>
            </thead>

            <tbody>
              {this.state.extratBill &&
                this.state.extratBill.map((extrat) => (
                  <tr>
                    <td>{extrat.name}</td>
                    <td>{extrat.value} DNT</td>
                    {/* <td>{extrat.description}</td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>)

      // return <ExtratFacture extracts={this.state.extratBill} />;
    }
  }

  render() {
    // var urlGeneratePDF =
    //   "http://localhost:8089/BonCommande/downloadBCDraft/" +
    //   localStorage.getItem("idBC");
    if (this.state.redirect) {
      return <Navigate replace to="/viewBCDetails" />;
    } else {
      return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
          <br />
          <section className="content">
            {/* {this.alertHandler()}
            {this.alertHandlerFile()} */}
            <div class="row">
              <SocieteBox societe={this.state.societeCliente} role="cliente" />
              <SocieteBox societe={this.state.societePartner} />
            </div>
            <ToastContainer delay={5000} />

            <br />
            <div class="container-fluid">
              <div class="card card-light">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="page-header">
                        {this.state.BC.title}
                      </h2>
                    </div>
                    <div class="col-md-6">
                      <div class="row float-right">
                        <br />
                        <div class="col-md-11 ">
                          <h5>
                            Date: {UtilsFormule.formatDate(
                              this.state.BC.creationDate
                            )}
                          </h5>
                        </div>
                        <div class="col-md-1">
                          <a href={this.state.BC.urlFileBC}>
                            <button class="btn btn-secondary float-right">
                              <i class="fa fa-download"></i>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      {/* title row */}

                      <div className="row">
                        <div className="col-md-6 invoice-col">
                          Détails Facture
                          <address>
                            <strong>
                              {this.state.BC.refBC}/{this.state.BC.yearRefBC}-
                              {this.state.BC.title}
                            </strong>
                            <br />
                            {this.state.BC.sujet}
                            <br />
                            {this.state.BC.description}
                            <br />
                          </address>
                        </div>

                        <SocieteFactureBox
                          societe={this.state.societeCliente}
                          role="From"
                        />
                        <SocieteFactureBox
                          societe={this.state.societePartner}
                          role="To"
                        />
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          {this.state.extratBill && (this.addExtratToView())}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-8"></div>
                        <div class="col-md-4">
                          <p className="lead">
                            Total
                          </p>
                          <div className="table-responsive">
                            <table className="table">
                              <tbody>
                                <tr>
                                  <th style={{ width: "50%" }}>Total HT:</th>
                                  <td>{this.state.BC.amountBC} DNT</td>
                                </tr>
                                <tr>
                                  <th>TVA</th>
                                  <td>{this.state.BC.tva} DNT</td>
                                </tr>
                                <tr>
                                  <th>Timbre:</th>
                                  <td>{this.state.BC.timbre} DNT</td>
                                </tr>
                                <tr>
                                  <th>Total TT:</th>
                                  <td>{this.state.BC.amountTT} DNT</td>
                                </tr>

                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col-md-10"></div>
                    <div class="col-md-1">
                      <button
                        onClick={(e) => {
                          this.deleteBCDraft(e);
                        }}
                        className="btn btn-dark float-right"
                      >
                        <i class="fas fa-times-circle"></i>

                      </button>
                    </div>
                    <div class="col-md-1">
                      <button
                        onClick={(e) => {
                          this.validateBC();
                        }}
                        className="btn bg-black float-right"
                      >
                        <i class="fas fa-check"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    }
  }
}
